import isEqual from 'lodash/isEqual'
import { isPdfPlacement } from './pdfOverlayCoordinate.util'

const TEXT_TYPES = ['text', 'object', 'search_param', 'texteditor']
const TEXT_STYLE_FIELDS = [
  'fontFamily', 'fontSizePt', 'lineHeightPt', 'textAlign', 'fontWeight',
  'fontStyle', 'color', 'verticalAlign', 'paddingPt',
]
const STYLE_PROPERTIES = {
  fontFamily: ['fontFamily'],
  fontSize: ['fontSizePt', 'lineHeightPt'],
  lineHeight: ['lineHeightPt'],
  fontWeight: ['fontWeight'],
  fontStyle: ['fontStyle'],
  textColor: ['color'],
  textAlign: ['textAlign'],
  verticalAlign: ['verticalAlign'],
  textClass: TEXT_STYLE_FIELDS,
}

export const needsPdfMeasurement = (item) =>
  !isPdfPlacement(item?.pdfPlacement) ||
  (TEXT_TYPES.includes(item?.type) && TEXT_STYLE_FIELDS.some(
    (field) => item?.pdfTextStyle?.[field] == null,
  ))

// DOM styles are only defaults for missing fields, never replacements for
// persisted PDF values (including zero padding).
export const mergePdfMeasurement = (item, pdfPlacement, pdfTextStyle) => ({
  ...(!isPdfPlacement(item?.pdfPlacement) ? { pdfPlacement } : {}),
  ...(pdfTextStyle ? {
    pdfTextStyle: {
      ...item?.pdfTextStyle,
      ...Object.fromEntries(TEXT_STYLE_FIELDS.map((field) => [
        field, item?.pdfTextStyle?.[field] ?? pdfTextStyle[field],
      ])),
    },
  } : {}),
})

export const invalidateChangedPdfGeometry = (item, previousItem) => {
  const nextItem = { ...item }
  if (!previousItem || ['left', 'top', 'width', 'height', 'page'].some(
    (field) => !isEqual(item[field], previousItem[field]),
  )) {
    delete nextItem.pdfPlacement
  }
  if (!previousItem) return nextItem

  if (item.type !== previousItem.type) {
    delete nextItem.pdfTextStyle
  } else if (nextItem.pdfTextStyle) {
    nextItem.pdfTextStyle = { ...nextItem.pdfTextStyle }
    Object.entries(STYLE_PROPERTIES).forEach(([property, fields]) => {
      if (!isEqual(item[property], previousItem[property])) {
        fields.forEach((field) => delete nextItem.pdfTextStyle[field])
      }
    })
  }
  return nextItem
}
